import api from '../api';

export const startTestApi = api.injectEndpoints({
  endpoints: builder => ({
    getFullTestDetails: builder.query({
      query: ({ userTestId, userId }) => ({
        url: '/api/interview/usertest/user/test',
        method: 'GET',
        params: { userTestId, userId }
      })
    }),
    getWrittenTestFullDetails: builder.query<
      any,
      { userTestId: string; userId?: string }
    >({
      query: ({ userTestId, userId }) => ({
        url: '/api/usertest/test/details',
        method: 'GET',
        params: { userTestId, userId }
      })
    }),
    getInterviewTestResults: builder.query<
      any,
      { size: number; page: number; userId: string }
    >({
      query: ({ size, page, userId }) => ({
        url: '/api/interview/usertest/user/tests',
        method: 'GET',
        params: { page, size, userId }
      })
    }),
    getColorCodes: builder.query({
      query: () => ({
        url: '/api/colorcode/fetchall',
        method: 'GET'
      })
    })
  })
});

export const {
  useLazyGetFullTestDetailsQuery,
  useLazyGetWrittenTestFullDetailsQuery,
  useLazyGetInterviewTestResultsQuery,
  useGetColorCodesQuery
} = startTestApi;
